"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ModeratorIcon_1 = __importDefault(require("../../assets/icons/ModeratorIcon"));
const DefaultUserIcon_1 = __importDefault(require("../../assets/icons/DefaultUserIcon"));
const BotIcon_1 = __importDefault(require("../../assets/icons/BotIcon"));
const UserIcon = ({ type, width = 24, height = 24 }) => {
    switch (type) {
        case 'moderator':
            return (0, jsx_runtime_1.jsx)(ModeratorIcon_1.default, { width: width, height: height });
        case 'guest':
            return (0, jsx_runtime_1.jsx)(BotIcon_1.default, { width: width, height: height });
        default:
            return (0, jsx_runtime_1.jsx)(DefaultUserIcon_1.default, {});
    }
};
exports.UserIcon = UserIcon;
